import React from "react"
import { observer } from "mobx-react-lite"

import Select from "@components/ui/MultiSelect/Select"
import { COUNTRIES, formatCountry } from "@framework/constants/countries"
import { Option } from "@framework/types/utils"
import { useStore } from "@store/index"

import { useMarketFilterContext } from "./MarketFilterContext"

import styles from "./MarketFilter.module.sass"

const MARKET_OPTIONS: Option[] = COUNTRIES.map((c) => ({
  name: c.name,
  value: formatCountry(c.name, c.code),
}))

const MarketFilter: React.FC = observer(() => {
  const { userStore } = useStore()
  const { countries, setCountries, locked } = useMarketFilterContext()

  if (!userStore.isSuperAdmin && !locked) {
    return null
  }

  if (locked) {
    const label = countries[0]
      ? formatCountry(countries[0])
      : "No market assigned"
    return (
      <div className={styles.locked} title="Admins can only view their own market">
        Market: {label}
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <Select
        isMulti
        clearable
        searchable
        placeholder="All markets"
        options={MARKET_OPTIONS}
        value={countries}
        onChange={(value) => setCountries([...(value ?? [])])}
      />
    </div>
  )
})

export default MarketFilter
